<template>
  <el-card shadow="hover">
    <label slot="header">级联选择</label>
    <el-divider content-position="left">根据提供的级联key，获取对应值</el-divider>
    <j-cascader type="select" code="INDUSTRY" value="1"/>
    <el-divider content-position="left">指定数据源tree（单选）</el-divider>
    <j-cascader type="select" :tree="tree" v-model="selected" placeholder="请选择数据" />
    <el-divider content-position="left">多选 multiple</el-divider>
    <j-cascader type="text" :tree="tree" v-model="selected" multiple />
    <j-cascader type="select" :tree="tree" v-model="selected" multiple placeholder="请选择数据" />
    <el-divider content-position="left">任意一级可选:props="{ checkStrictly: true }"</el-divider>
    <j-cascader type="select" :tree="tree" v-model="selected" placeholder="请选择数据" :props="{ checkStrictly: true }" />
    <el-divider content-position="left">默认属性对应关系为{{defaultKeyValue}},使用自定义属性值{{keyValueChild}}</el-divider>
    <j-cascader type="text" :tree="treeKeyValueChild" v-model="selected" :label-value="keyValueChild" />
    <j-cascader type="select" :tree="treeKeyValueChild" v-model="selected" multiple placeholder="请选择数据" :label-value="keyValueChild" />
    <el-divider content-position="left">文本模式</el-divider>
    <j-cascader type="text" :tree="tree" value="1/12" />
  </el-card>
</template>

<script>
import JCascader from "./JCascader.vue";
export default {
  components: {
    JCascader
  },
  data () {
    return {
      defaultKeyValue: {label: 'label', value: 'value', children: 'children'},
      keyValueChild: {
        label: 'value',
        value: 'key',
        children: 'child'
      },
      selected: '',
      tree: [{
        "label":"一级",
        "value":"1",
        "children":[{
          "label":"二级",
          "value":"12",
          "children":[{
            "label":"三级",
            "value":"123",
            "children":null
          }]
        }]
      }],
      treeKeyValueChild: [{
        "value":"自定义一级",
        "key":"1",
        "child":[{
          "value":"自定义二级",
          "key":"12",
          "child":[{
            "value":"自定义三级",
            "key":"123",
            "child":null
          }]
        }]
      }]
    }
  }
}
</script>